import React from 'react';
import PropTypes from 'prop-types';

import { Box, Text } from '@components/atoms';
import { CustomContainer } from '@components/molecules';
import { GetParsedColor } from '@styles';

const Subheading = ({ question }) => {
    const blue = GetParsedColor('blue');
    const black = GetParsedColor('black');

    return (
        <>
            <Box
                style={{
                    background: `linear-gradient(to left, ${black}, ${blue})`,
                    borderRadius: 7,
                    height: 15,
                    marginTop: '10vh',
                }}
            />
            <CustomContainer style={{ position: 'relative', textAlign: 'center' }}>
                <Text
                    bold
                    color="black"
                    fontSize={20}
                    mb="3%"
                    translate={false}
                >
                    {question.statement}
                </Text>
                <Text
                    style={{
                        flexWrap: 'wrap',
                        textAlign: 'justify',
                        whiteSpace: 'pre-line',
                        wordWrap: 'break-word',
                    }}
                    translate={false}
                >
                    {question.context}
                </Text>
            </CustomContainer>
        </>
    );
};

Subheading.propTypes = {
    question: PropTypes.shape({
        context: PropTypes.string,
        statement: PropTypes.string,
    }).isRequired,
};

export default Subheading;
